import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class ZoneLine extends Resource {
    public override type = 'zoneLines';

    @prop()
    @required()
    public value!: string;

    @prop()
    public zoneId!: string;

}